var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 25C27.7614 25 30 22.7614 30 20C30 17.2386 27.7614 15 25 15C22.2386 15 20 17.2386 20 20C20 22.7614 22.2386 25 25 25ZM28.3333 20C28.3333 21.8409 26.8409 23.3333 25 23.3333C23.1591 23.3333 21.6667 21.8409 21.6667 20C21.6667 18.1591 23.1591 16.6667 25 16.6667C26.8409 16.6667 28.3333 18.1591 28.3333 20Z",
    fill: "#0FCB02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 33.3333C35 35 33.3333 35 33.3333 35H16.6667C16.6667 35 15 35 15 33.3333C15 31.6667 16.6667 26.6667 25 26.6667C33.3333 26.6667 35 31.6667 35 33.3333ZM33.3333 33.3275C33.3309 32.9162 33.077 31.6841 31.9465 30.5535C30.8594 29.4664 28.8152 28.3333 25 28.3333C21.1848 28.3333 19.1406 29.4664 18.0535 30.5535C16.9229 31.6841 16.669 32.9162 16.6667 33.3275H33.3333Z",
    fill: "#0FCB02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLink);
export default __webpack_public_path__ + "static/media/profile-link.00204d12f763cd8dd2bf36f1f760bf08.svg";
export { ForwardRef as ReactComponent };